import { Injectable } from '@angular/core';
import { LocalStorageEnum } from 'src/app/shared/enum.ts/local-storage.enum';
import { IUserToken } from 'src/app/shared/models/local-storage';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {
    constructor() {}

    getItem(key: LocalStorageEnum) {
        return JSON.parse(localStorage.getItem(key));
    }

    setItem(key: LocalStorageEnum, object: any) {
        localStorage.setItem(key, JSON.stringify(object));
    }
}
